import { render, staticRenderFns } from "./ModalViewPDF.vue?vue&type=template&id=1481b475&scoped=true&"
import script from "./ModalViewPDF.vue?vue&type=script&lang=ts&"
export * from "./ModalViewPDF.vue?vue&type=script&lang=ts&"
import style0 from "./ModalViewPDF.vue?vue&type=style&index=0&id=1481b475&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1481b475",
  null
  
)

export default component.exports